export default "__VITE_ASSET__5c6c3770__"